import { Store } from 'redux'

import { setIsOnline } from './appReducer'
import { IEllipsisReduxStore } from './types'

const originalFetch = window.fetch

export default function register(
  theWindow: Window,
  store: Store<IEllipsisReduxStore>
) {
  theWindow.addEventListener('online', () => {
    store.dispatch(setIsOnline(true))
  })

  theWindow.addEventListener('offline', () => {
    store.dispatch(setIsOnline(false))
  })

  // Replace the fetch API with an implementation that can intercept requests / responses
  theWindow.fetch = function (...args) {
    return new Promise((resolve, reject) => {
      originalFetch
        .apply(this, args)
        .then((response) => {
          return resolve(response)
        })
        .catch((error) => {
          if (!navigator.onLine) {
            store.dispatch(setIsOnline(false))
          }
          return reject(error)
        })
    })
  }
}
